import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, Multilingual } from 'hyperdb-utils';

const MultilingualField = Multilingual(TextInput);

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <fieldset>
        <MultilingualField
          label="Name"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
          availableLocales={ this.props.availableLanguages }
        />
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
}

Form.propTypes = {
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(Form, {
  namespace: 'amenity',
  mountedUrl: '/amenities',
  titleNew: 'Create new amenity',
  titleEdit: 'Edit amenity',
  displayName: (object) => object.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/amenity/containers/Form.jsx